<template>
  <v-card>
    <v-card id="topbar">
      <!--TopBar for all Menue-->
      <v-app-bar class="secondary" id="topbar">
        <v-toolbar-title>
          <div class="d-flex align-center">
            <v-img
              alt="Workpass Logo"
              class="shrink"
              min-width="60"
              contain
              src="@/assets/AdjustermateLogo512.png"
              transition="scale-transition"
              width="50"
            />
            <v-toolbar-title class="font-weight-bold title white--text">AdjusterMate</v-toolbar-title>
          </div>
          <div></div>
        </v-toolbar-title>
        <!-- <div>
              <span class="font-weight-bold title white--text" id="title">AdjusterMate</span>
        </div>-->

        <!-- <div >
            <v-img src="@/assets/logo.png" class="display-1" id="Logo"></v-img>

        -->
        <v-spacer></v-spacer>
        <span class="mr-3 white--text">
          {{this.$store.getters.get_OrgDetails.org_emailid}}
          <br />
          <div style="font-size:14px" align="center">{{this.$store.getters.get_OrgDetails.org_name}}</div>
        </span>
        <v-btn id="logout-label" class="secondary" @click="logout">Logout</v-btn>

        <!-- </div> -->
      </v-app-bar>
    </v-card>
  </v-card>
</template>
<script>
export default {
  data: () => ({
    apkid: "",
    orgId: "",
    orgDetails: "",
    userDetail: ""
  }),
  created() {
    this.getAllMethodSetter();
  },
  methods: {
    getAllMethodSetter() {
      this.apkid = this.$store.getters.get_OrgDetails.org_apikey;
      this.orgDetails = this.$store.getters.get_OrgDetails;
      // console.log("orgDetails", this.orgDetails);
      this.orgId = this.$store.getters.get_OrgDetails.org_id;
      this.userDetail = this.$store.getters.get_OrgDetails.org_adminid;
      this.$store.commit("SET_USERAdminidID", this.userDetail);

      this.$store.commit("SET_ApiId", this.apkid);
      this.$store.commit("SET_OrgId", this.orgId);
      this.$store.commit("SET_OrgDetails", this.orgDetails);
    },
    logout() {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
#topbar {
  position: relative;
  width: 100%;
}
#Logo {
  position: fixed;
  width: 42px;
  height: 42px;
  margin-top: -20px;
  margin-left: -45px;
}
#title {
  position: fixed;
  margin-top: -12px;
}
#logout {
  position: fixed;
  padding-left: 1040px;
  margin-top: -12px;
}
#logout-label {
  font-size: 15px;
}
</style>



